import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { ReconciliationForm } from './ReconciliationForm/ReconciliationForm';

export const reconciliationResource: ResourceProps = {
  name: Resources.Reconciliation,
  list: ReconciliationForm,
  create: <></>,
  edit: <></>,
  show: <></>,
};
